import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  jobs = [
    {
      year: "2022 - Today",
      id: "ex1",
      company: "Opinno - HP Barcelona",
      position: "Senior Product Designer",
      description: "",
    },
    {
      year: "2021 - 2022",
      id: "ex2",
      company: "Devex Barcelona",
      position: "Senior Product UX/UI Designer",
      description:
        "I worked on the visual interface of Devex website. I took care that it looked clear and consistent. This involved both the visual aspects of the site and the underlying code that displayed the interface.",
      descriptions: [
        "Lead design processes from conceptualization to the implementation phases.",
        "Conducted user research through interviews, surveys, user flows, customer/user journey, user personas, among others, to take data-driven solutions.",
        "Delivered a final product with mockups and high-fidelity prototypes.",
        "Drived the change of the website UI to maintain consistency by creating reusable design components and constructive patterns.",
        "Conducted product presentations to stakeholders.",
      ],
    },
    {
      year: "2017 - 2021",
      id: "ex3",
      company: "Devex Barcelona",
      position: "Product UX/UI Designer & Front-end Developer",
      descriptions: [
        "Worked in design processes from conceptualization to the implementation phases.",
        "Made user research through interviews, surveys, user flows, user personas, among others. ",
        "Delivered design solutions.",
        "Wrote code that displays the interface using tech languages: HTML, CSS & SASS, Bootstrap, Vanilla JS, Angular, React, among others.",
        "Worked in collaboration among different teams like designers, developers, and stakeholders, presenting ideas and adjusting the design based on constructive feedback.",
      ],
    },
    {
      year: "2015 - 2017",
      id: "ex4",
      company: "Multiplica Barcelona",
      position: "Front-end Developer",
      description: "Front-end Developer, programming websites to power the visual and interaction.",
      descriptions: [
        "Implemented prototypes using different design patterns and front-end frameworks as requested by each client.",
        "Generated prototypes among others with: HTML, CSS, SASS & LESS, Bootstrap, Vanilla JS, jQuery, Angular, Vue, PHP.",
        "Collaboration with different teams like UX researchers, UI designers, and developers.",
        "The main clients were Andorra tourism, Aegon, Melia Hotels, Hotels Catalonia, Catalana Occidente, Edenred,  Universia, and Gadgets Cuina.",
      ],
    },
    {
      year: "2014 - 2015",
      id: "ex5",
      company: "Ogilvy Barcelona",
      position: "UI Designer Internship",
      descriptions: [
        "Designed landing pages, website sections, banners, and social media graphics for a campaign & a strategy.",
        "Developed designs following the visual language and interaction design principles inside the campaigns.",
        "The main clients were Nestle, La Caixa, Gas Natural, Avene, Boots Laboratories, TMB BCN, and Unilever.",
      ],
    },
    {
      year: "2012 - 2014",
      id: "ex6",
      company: "House Rapp Costa Rica",
      position: "Graphic Designer & Web Developer",
      descriptions: [
        "Developed and presented ideas, concepts, and design solutions for advertising campaigns.",
        "Designed and produced a wide range of assets: newsletters, landing pages, banners, point of sale ads, newspaper & magazine ads, etc.",
        "The main clients were Citibank Costa Rica, Microsoft, Demasa, Preserve Planet, and 3M.",
      ],
    },
    {
      year: "2011 - 2012",
      id: "ex7",
      company: "Partner Centroamérica",
      position: "Graphic Designer",
      descriptions: [
        "Assisted visual communication covering branding design, point of sale ads, newspaper ads, catalogues, among others.",
        "The main clients were Cervecería of Costa Rica, Papa John’s, and Paseo de las Flores Mall.",
      ],
    },
  ];

  educationStudies = [
    {
      year: "2021 -  2022",
      id: "ed0",
      title: "University of Alcalá",
      secondaryTitle: "Samsung Desarrolladoras",
      descriptions: [
        "Course for women developers covering basic knowledge of web development, and web applications using standards such as HTML5, CSS and JavaScript. Other full stack development topics as Angular, Node.js and JSON.",
      ],
    },
    {
      year: "2021",
      id: "ed1",
      title: "Codeacademy",
      secondaryTitle: "Learn React Testing Course",
      descriptions: [
        "Testing course with Jest. The Jest testing framework focuses on simplicity and ease of use, providing all the tools needed to write unit tests.",
      ],
    },
    {
      year: "2020",
      id: "ed2",
      title: "Udemy",
      secondaryTitle: "The Complete Figma Course",
      descriptions: ["Designing mobile & web app  UI/UX"],
    },
    {
      year: "2019",
      id: "ed3",
      title: "University of Helsinki",
      secondaryTitle: "Full Stack Open 2019 Course",
      descriptions: [
        "Online course of React, Redux, Node.js, MongoDB, GraphQL and TypeScript",
        "www.fullstackopen.com",
      ],
    },
    {
      year: "2014 - 2015",
      id: "ed4",
      title: "Elisava Barcelona School of Design and Engineering",
      secondaryTitle: "Master's Degree Diploma in Design and Internet Web Project Direction",
      descriptions: [
        "Postgraduate Diploma in Web Project Management and Design",
        "Postgraduate Diploma in Web Design of Network Applications and Services",
        "Participation in the Interaction Design Workshop with Irene Pereyra",
      ],
    },
    {
      year: "2008 - 2012",
      id: "ed5",
      title: "Veritas University Costa Rica",
      secondaryTitle: "Bachelor's Degree in Advertising Design",
      descriptions: [
        "Bachelor's degree that included different advertising areas: design, copywriting, web design, multimedia, merchandising and strategy",
      ],
    },
    {
      year: "2003 - 2008",
      id: "ed6",
      title: "Lincoln High School Costa Rica",
      descriptions: [
        "United States Baccalaureate",
        "Costa Rican Baccalaureate - Ministerio de Educación Pública",
        "International Baccalaureate - IBO Visual Arts & Spanish A2",
      ],
    },
  ];

  awards = [
    {
      year: "2016",
      id: "awa0",
      title: "FID",
      secondaryTitle: "Costa Rica Internacional Design Festival",
      descriptions: [
        "The final projects of the Master: Tizo and Shipwish were selected to be presented in Costa Rica Internacional Design Festival",
      ],
    },
    {
      year: "2014",
      id: "awa1",
      title: "Volcán Festival",
      secondaryTitle: "Costa Rica Advertising Awards",
      descriptions: [
        "Golden Volcano | Category Use of Direct Marketing: Stories of the Wild, Preserve Planet",
        "Silver Volcano | Category Exteriors Environment Small Scale: Stories of the Wild, Preserve Planet",
        "Silver Volcano | Category Exteriors Experiential: Stories of the Wild, Preserve Planet",
        "Bronze Volcano | Category Mobile, use of technology: The Why-fi, Telecable",
      ],
    },
    {
      year: "2014",
      id: "awa2",
      title: "Ojo Iberoamérica Festival",
      secondaryTitle: "Argentina",
      descriptions: [
        "Finalist | Category MB3 – Sites/ Microsites and Apps | The Why-fi, Telecable",
      ],
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/about/about.component.ts